import React from "react";
import ISOCertificationImg from "../../../Assets/ISO Certification/CertificationImg.png";

const ISOContent9001 = () => {
  return (
    <>
      <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
        {/* left side */}
        <div className="w-full">
          {/* heading */}
          <div className="py-4 lg:py-10">
            <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
              <h1 className="mb-3">
                <span className="border-b-4 border-[#249742]"> ISO 90</span>
                01 CERTIFICATION
              </h1>
            </div>
          </div>

          {/* content */}
          <div>
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              ISO 9001 sets out the criteria for a quality management system and
              is the only standard in the family that can be certified to
              (although this is not a requirement). It can be used by any
              organization, large or small, regardless of its field of activity.
              In fact, there are over one million companies and organizations in
              over 170 countries certified to ISO 9001. This standard is based
              on a number of quality management principles including a strong
              customer focus, the motivation and implication of top management,
              the process approach and continual improvement. These principles
              are explained in more detail in ISOs quality management
              principles. Using ISO 9001 helps ensure that customers get
              consistent, good-quality products and services, which in turn
              brings many business benefits.
            </p>
          </div>
        </div>

        {/* right side */}
        <div className="grid grid-cols-1">
          <div className="py-0 sm:py-8">
            <img
              src={ISOCertificationImg}
              className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
              alt="Compliance certificate"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOContent9001;
